import { ReactElement } from 'react';

import * as S from './Rating.styles';
import { TRatingStars } from '@/common/domain/Rating.domain';

export type RatingProps = {
    rating: TRatingStars;
};

const Rating = ({ rating }: RatingProps): ReactElement => {
    const { full, half } = rating;

    if (full + half < 1 || full + half > 5) {
        return <></>;
    }

    return (
        <S.Rating data-test-id="Rating">
            {Array.from({ length: 5 }, (_, i) => {
                if (i < full) {
                    return (
                        <svg width="11" height="10" key={i}>
                            <use href="#icon-start-filled"></use>
                        </svg>
                    );
                }
                if (i === full && half === 1) {
                    return (
                        <svg width="12" height="10" key={i}>
                            <use href="#icon-start-half"></use>
                        </svg>
                    );
                }
                return (
                    <svg width="11" height="10" key={i}>
                        <use href="#icon-start-empty"></use>
                    </svg>
                );
            })}
        </S.Rating>
    );
};

export { Rating };
